import React from 'react';
import { FormattedMessage } from 'react-intl';

export default ({ intl, form, onChange, ...props }) => (
    <div {...props}>
        <h6 className="title is-6">
            <FormattedMessage id="exhibitApplication.contactsTitle" />
        </h6>
        <h6 className="subtitle" style={{ fontSize: '70%' }}>
            <FormattedMessage id="exhibitApplication.contactsSubtitle" />
        </h6>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="text"
                    name="name"
                    placeholder={intl.formatMessage({
                        id: 'contactForm.name',
                    })}
                    value={form.name}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="text"
                    name="contactPerson"
                    placeholder={intl.formatMessage({
                        id: 'contactForm.contactPerson',
                    })}
                    value={form.contactPerson}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="text"
                    name="address"
                    placeholder={intl.formatMessage({
                        id: 'contactForm.address',
                    })}
                    value={form.address}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="tel"
                    name="tel"
                    placeholder={intl.formatMessage({
                        id: 'contactForm.tel',
                    })}
                    value={form.tel}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="email"
                    name="email"
                    placeholder={intl.formatMessage({
                        id: 'contactForm.email',
                    })}
                    value={form.email}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="text"
                    name="website"
                    placeholder={intl.formatMessage({
                        id: 'contactForm.website',
                    })}
                    value={form.website}
                    onChange={onChange}
                />
            </div>
        </div>
        {/* <div className="field">
            <div className="control" onChange={onChange}>
                <label className="label">
                    <FormattedMessage id="contactForm.formatLabel" />:
                </label>
                <label className="radio">
                    <input
                        type="radio"
                        name="format"
                        value="stand"
                        defaultChecked
                    />
                    &nbsp;<FormattedMessage id="contactForm.stand" />
                </label>
                <label className="radio">
                    <input type="radio" value="static" name="format" />
                    &nbsp;<FormattedMessage id="contactForm.static" />
                </label>
            </div>
        </div> */}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/ContactForm/components/Contacts.js